import React, { useEffect, useRef, useState } from "react";
import useOutsideClick from "../hooks/useOutsideClick";
import { useGetProfile } from "../Controllers/UserProfileController";
import { db } from "../Utils/firebase";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { Link } from "react-router-dom";
import { FIREBASE_CONVERSATIONS } from "../Utils/constant";
import {
  getUnreadCountForUser,
  isLastMessageFromUser,
} from "../Utils/chatUnread";
// import { getToken, onMessage } from "firebase/messaging";
// import { messaging } from "../Utils/firebase";

const HeaderNotification = ({ isDropdownVisible, toggleDropdown }) => {
  const [notifications, setNotifications] = useState([]);
  const [userId, setUserId] = useState(null);

  // Use the new controller hook
  const { data: userProfile, isLoading: profileLoading } = useGetProfile();

  useEffect(() => {
    if (userProfile?.id) {
      setUserId(userProfile.id);
    }
  }, [userProfile?.id]);

  useEffect(() => {
    if (!userId) return;
    const q = query(
      collection(db, FIREBASE_CONVERSATIONS),
      where("participants", "array-contains", String(userId)),
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const newNotifs = [];
      snapshot.forEach((doc) => {
        const data = doc.data();

        if (!data.visibleTo?.includes(String(userId))) return;

        // Sanity check: Ensure user is in participantDetails (critical for groups)
        const isInDetails =
          data.type === "group"
            ? data.participantDetails &&
              String(userId) in data.participantDetails
            : true;

        if (!isInDetails) return;

        const unreadCount = getUnreadCountForUser(data.unreadCount, userId);

        const senderInfo =
          data.participantDetails?.[String(data.lastMessageSenderId)] ||
          data.participantDetails?.[Number(data.lastMessageSenderId)] ||
          {};

        // Check if current user is mentioned in the last message
        const mentionedInLastMessage = data.lastMessageMentionedIds?.includes(
          String(userId),
        );

        if (
          (unreadCount > 0 &&
            !isLastMessageFromUser(data.lastMessageSenderId, userId)) ||
          mentionedInLastMessage
        ) {
          newNotifs.push({
            senderName: senderInfo.name || "Unknown",
            message: data.lastMessage.replace(/<[^>]+>/g, ""),
            unreadCount,
            mentioned: mentionedInLastMessage,
            conversationId: doc.id || data.conversationId,
            // Track if last message is from a thread for navigation
            lastMessageThreadId: data.lastMessageThreadId || null,
          });
        }
      });
      setNotifications(newNotifs);
    });

    return () => unsubscribe();
  }, [userId]);

  const dropdownRef = useRef(null);
  useOutsideClick(dropdownRef, () => {
    if (isDropdownVisible) {
      toggleDropdown();
    }
  });

  return (
    // ...existing JSX
    <div className="header-icons" ref={dropdownRef} onClick={toggleDropdown}>
      <img alt="image-alt" className="main-icons" src="/icons/mail.svg" />
      <img
        alt="notification dot"
        className="notification-dot"
        src="/icons/Skeleton.svg"
        style={{
          display: notifications.length === 0 ? "none" : "block",
        }}
      />
      {/* Dropdown */}
      {isDropdownVisible && (
        <div
          className="notification-dropdown"
          style={{
            background: "rgba(28, 41, 52, 0.6)",
            backdropFilter: "blur(5px) saturate(10%)",
            WebkitBackdropFilter: "blur(5px) saturate(120%)",
            color: "#fff",
          }}
        >
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {notifications.length > 0 ? (
              notifications.map((notification, index) => (
                <React.Fragment key={notification.id || index}>
                  <Link
                    key={index}
                    to={
                      notification.lastMessageThreadId
                        ? `/threads?conversationId=${notification.lastMessageThreadId}`
                        : `/chat?conversationId=${notification.conversationId}`
                    }
                    className="text-decoration-none"
                  >
                    <li
                      style={{
                        padding: "10px 0",
                        borderBottom:
                          index !== notifications.length - 1
                            ? "1px solid #fff" // white divider with some transparency
                            : "none",
                      }}
                    >
                      <span>
                        <span style={{ fontWeight: 600, color: "#fff" }}>
                          "{notification.senderName}"
                        </span>{" "}
                        {notification.mentioned ? (
                          <span style={{ color: "#fff" }}>mentioned you</span>
                        ) : (
                          <span style={{ color: "#fff" }}>
                            sent you a message
                          </span>
                        )}
                      </span>
                    </li>
                  </Link>
                </React.Fragment>
              ))
            ) : (
              <span className="text-body-b3-color">
                You have no new messages
              </span>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default HeaderNotification;
